<template>
  <div class="card-status-small">
    <div class="info-block">
      <div class="user-row">
        <!-- プロフィール画像 -->
        <b-card-img
          v-bind:src="profileImageUrl"
          class="profile-icon"
          crossorigin="use-credentials"
        />
        <!-- ユーザー名 -->
        <span class="user-name">
          {{ userName }}
        </span>
      </div>
      <div class="status-row">
        <!-- ステイタス名称 -->
        <span class="name">{{ statusName }}</span>
        <!-- ステイタス日時 -->
        <span class="date">{{ updateAtForDisplay }}</span>
      </div>
    </div>
    <div class="detail-block">
      <!-- 詳細リンク -->
      <span
        class="detail-link"
        v-on:click="$_onClickDetail"
        v-t="'appCardStatusSmall.detail'"
      />
    </div>
  </div>
</template>

<script>
import { RestApiClient } from 'ifield-core-components'
import moment from 'moment'
import { DATE_FORMAT_SLASH, TIME_FORMAT_MINUTE } from '@/constants.js'

const DATETIME_FORMAT = `${DATE_FORMAT_SLASH} ${TIME_FORMAT_MINUTE}`

export default {
  name: 'AppCardStatusSmall',
  props: {
    /**
     * ステイタスID
     */
    id: {
      type: Number,
      default: null,
      required: true,
    },
    /**
     * ステイタス更新日時
     */
    updateAt: {
      type: [String, Date],
      default: null,
    },
    /**
     * ステイタス名
     */
    statusName: {
      type: String,
      default: '',
    },
    /**
     * ユーザーID
     */
    userId: {
      type: Number,
      default: null,
    },
    /**
     * ユーザー名
     */
    userName: {
      type: String,
      default: '',
    },
  },
  computed: {
    /**
     * プロフィール画像のURL
     * @type {String}
     */
    profileImageUrl: function () {
      // ダウンロードファイルAPI
      const url = RestApiClient.createApiUrl('download_file')
      const params = url.searchParams
      params.append('id', this.userId)
      params.append('thumbnail', 1)
      params.append('attach_file_type', 9)
      return url.toString()
    },
    /**
     * 表示用日時
     * @type {String}
     */
    updateAtForDisplay: function () {
      const m = moment(this.updateAt)
      if (!m.isValid()) return ''
      return m.format(DATETIME_FORMAT)
    },
  },
  methods: {
    /**
     * 詳細リンククリック時処理
     */
    $_onClickDetail: function () {
      /**
       * 詳細クリックイベント
       * @param {Number} id 対象チェックインID
       */
      this.$emit('detail-click', this.id)
    },
  },
}
</script>

<style lang="scss" scoped>
.card-status-small {
  max-width: 16rem;
  height: 5.5rem;
  display: grid;
  grid-template-columns: 1fr max-content;
  align-items: center;
  column-gap: 32px;
  font-size: $font-size-middle;
  padding: 8px;
  overflow: hidden;
  user-select: none;
}

.info-block {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-start;
}

.user-row {
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr);
  align-items: center;
  column-gap: 8px;

  .profile-icon {
    width: 24px;
    height: 24px;
    border-radius: 50%;
  }

  .user-name {
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

.status-row {
  display: grid;
  grid-template-rows: 1fr max-content;
  grid-template-columns: minmax(0, 1fr);
  justify-items: start;
  align-items: start;
  padding-left: 2px;

  .name {
    max-width: 100%;
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .date {
    color: #959595;
    font-size: $font-size-small;
    line-height: 1;
  }
}

.detail-block {
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}

.detail-link {
  color: #006d30;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}
</style>
